const scriptTag = document.createElement('script');
scriptTag.src = "https://cdn.mazing.link/mzg-in.js";
scriptTag.type = "text/javascript";
scriptTag.crossOrigin = "anonymous";
scriptTag.defer = true;
document.head.append(scriptTag);

let currentProduct;
let iframeSrc;
let iframeElement;
let customer = 'WOJTEKJMSOFASCOUK';
let isMazingSelected = false;
let lockedActiveIndex = null;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};

const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '').pop();
    const productParts = product.split('?');
    currentProduct = `${productParts[0]}`;
    console.log('Final SKU:', currentProduct.toLowerCase());
    return currentProduct.toLowerCase();
};

const cloneAndInsertThumb = (thumbGallery, newImgSrc) => {
    const firstThumb = thumbGallery.children[0];
    if (!firstThumb) return;

    const clonedThumb = firstThumb.cloneNode(true);
    clonedThumb.id = 'mazing-thumb';

    const buttonInClone = clonedThumb.querySelector('button');
    if (buttonInClone) {
        buttonInClone.classList.remove('active');
    }

    const originalImg = clonedThumb.querySelector('img');
    if (!originalImg) return;

    originalImg.style.opacity = '0.4';
    originalImg.style.filter = 'brightness(120%) grayscale(100%)';
    originalImg.style.zIndex = '1';
    originalImg.style.position = 'relative';

    clonedThumb.style.position = 'relative';

    const overlayWrapper = document.createElement('div');
    overlayWrapper.style.position = 'absolute';
    overlayWrapper.style.top = '0';
    overlayWrapper.style.left = '0';
    overlayWrapper.style.width = '100%';
    overlayWrapper.style.height = '100%';
    overlayWrapper.style.padding = '5%';
    overlayWrapper.style.boxSizing = 'border-box';
    overlayWrapper.style.pointerEvents = 'none';

    const overlayImg = document.createElement('img');
    overlayImg.src = newImgSrc;
    overlayImg.id = 'mazing-img';
    overlayImg.style.width = '100%';
    overlayImg.style.height = '100%';
    overlayImg.style.padding = '10%';
    overlayImg.style.objectFit = 'contain';
    overlayImg.style.filter = 'brightness(0) saturate(100%) invert(27%) sepia(12%) saturate(21%) hue-rotate(5deg) brightness(89%) contrast(84%)';

    overlayWrapper.appendChild(overlayImg);
    clonedThumb.appendChild(overlayWrapper);
    if (thumbGallery.children.length > 1) {
        thumbGallery.insertBefore(clonedThumb, thumbGallery.children[1]);
    } else {
        thumbGallery.appendChild(clonedThumb);
    }
};

const insertIframe = (imgGallery, iframeSrc) => {
    const firstItem = imgGallery.children[0];
    if (!firstItem) return;

    const clonedItem = firstItem.cloneNode(true);
    clonedItem.id = 'mazing-iframe-item';

    if (window.innerWidth > 960) {
        clonedItem.classList.add('hidden');
    } else {
        clonedItem.style.width = '100%';
        clonedItem.style.height = '100%';
        clonedItem.style.background = '#FFFFFF';
    }

    const iframeWrapper = clonedItem.querySelector('div');
    if (iframeWrapper) {
        iframeWrapper.style.height = '100%';
    }

    const anchor = clonedItem.querySelector('a');
    if (anchor) {
        iframeElement = document.createElement('iframe');
        iframeElement.src = iframeSrc;
        iframeElement.width = '100%';
        iframeElement.height = '100%';
        iframeElement.style.border = 'none';
        iframeElement.setAttribute('allowusermedia', '');
        iframeElement.setAttribute('allowfullscreen', '');
        iframeElement.allow = "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera *; xr-spatial-tracking;";

        anchor.replaceWith(iframeElement);
    }

    if (imgGallery.children.length > 1) {
        imgGallery.insertBefore(clonedItem, imgGallery.children[1]);
    } else {
        imgGallery.appendChild(clonedItem);
    }

};


const setupThumbClickListeners = (thumbGallery, imgGallery) => {
    const thumbs = thumbGallery.children;
    const iframeItem = document.getElementById('mazing-iframe-item');

    for (let thumb of thumbs) {
        thumb.addEventListener('click', (e) => {
            e.preventDefault();

            for (let otherThumb of thumbs) {
                const button = otherThumb.querySelector('button');
                if (button) {
                    button.classList.remove('active');
                }
            }

            const clickedButton = thumb.querySelector('button');
            if (clickedButton) {
                clickedButton.classList.add('active');
            }

            if (window.innerWidth > 960) {
                if (thumb.id === 'mazing-thumb') {
                    if (imgGallery && iframeItem) {
                        for (let item of imgGallery.children) {
                            item.classList.add('hidden');
                        }
                        iframeItem.classList.remove('hidden');
                        isMazingSelected = true;
                    }
                } else {
                    if (iframeItem) {
                        iframeItem.classList.add('hidden');
                        isMazingSelected = false;
                    }
                }
            }
        });
    }
};

const setupThumbClickListenersMobile = (thumbGallery, imgGallery) => {
    const thumbs = Array.from(thumbGallery.children);
    const slides = Array.from(imgGallery.children);
    const iframeItem = document.getElementById('mazing-iframe-item');

    thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', (e) => {
            e.preventDefault();

            lockedActiveIndex = index;

            thumbs.forEach(t => {
                const b = t.querySelector('button');
                if (b) b.classList.remove('active');
            });

            const clickedButton = thumb.querySelector('button');
            if (clickedButton) {
                clickedButton.classList.add('active');
            }

            if (thumb.id === 'mazing-thumb') {
                if (imgGallery && iframeItem) {
                    isMazingSelected = true;
                }
            } else {
                if (iframeItem) {
                    isMazingSelected = false;
                }
            }

            const targetSlide = slides[index];
            if (targetSlide && typeof targetSlide.offsetLeft === 'number') {
                imgGallery.scrollTo({
                    left: targetSlide.offsetLeft,
                    behavior: 'smooth'
                });
            }
        });
    });
};

const assignThumbnailIndices = (thumbGallery) => {
    const thumbs = Array.from(thumbGallery.children);
    thumbs.forEach((thumb, i) => {
        thumb.setAttribute('data-thumbnail-index', i.toString());
    });
};

const assignSlideIndices = (imgGallery) => {
    const slides = Array.from(imgGallery.children);
    slides.forEach((slide, i) => {
        slide.setAttribute('data-slide-index', i.toString());
    });

    const scrollSlider = document.querySelector('.scroll-slider');

    if (scrollSlider && scrollSlider.sliderItems) {
        const itemsArray = Array.from(scrollSlider.sliderItems);
        itemsArray.push(imgGallery.children[0]);
        scrollSlider.sliderItems = itemsArray;
        scrollSlider.sliderItemsToShow = itemsArray;
        scrollSlider.totalPages += 1;
    }

};


const syncIframeHeight = (imgGallery) => {
    const iframeItem = document.getElementById('mazing-iframe-item');
    if (!imgGallery || !iframeItem) return;

    const firstItem = imgGallery.children[0];
    if (!firstItem) return;

    const firstItemHeight = firstItem.offsetHeight;
    iframeItem.style.height = `${firstItemHeight}px`;
};

const initializeVariantListeners = async () => {
    const groupContainer = await waitForElement('.product-form__controls-group');
    if (!groupContainer) return;

    const labelSpan = Array.from(groupContainer.querySelectorAll('span.form__label'))
        .find(span => span.textContent.trim().startsWith('Select a colour:'));

    if (!labelSpan) {
        console.warn('Label "Select a colour:" not found');
        return;
    }

    const labelContainer = labelSpan.closest('.tpo_option-label-container');
    if (!labelContainer) {
        console.warn('parent .tpo_option-label-container not found');
        return;
    }

    const swatchWrapper = labelContainer.parentElement.querySelector('.tpo_option-type-image-swatches-wrapper');
    if (!swatchWrapper) {
        console.warn('Swatch Wrapper not found');
        return;
    }

    const swatches = swatchWrapper.querySelectorAll('div');
    console.log('Swatches found:', swatches.length);

    swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
            const input = swatch.querySelector('input[type="radio"]');
            if (!input) return;

            const selectedValue = input.value;
            const cleanedValue = selectedValue
                .replace(/[()]/g, '')
                .replace(/\s+/g, '-')
                .toLowerCase();

            console.log("Selected variant value:", cleanedValue);

            iframeElement?.contentWindow?.postMessage({
                type: 'SWITCH_VARIANT',
                value: {
                    trigger: cleanedValue
                }
            }, '*');
        });
    });
};

const preventExternalActiveManipulation = (thumbGallery) => {
    const thumbs = Array.from(thumbGallery.children);

    const observer = new MutationObserver(() => {
        if (lockedActiveIndex === null) return;

        // Disconnect before making any DOM changes
        observer.disconnect();

        thumbs.forEach((thumb, index) => {
            const btn = thumb.querySelector('button');
            if (!btn) return;

            if (index === lockedActiveIndex) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        // Reconnect after
        observer.observe(thumbGallery, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
        });
    });

    observer.observe(thumbGallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });
};

const observeVisibleSlide = (imgGallery, thumbGallery) => {
    const slides = Array.from(imgGallery.children);
    const thumbs = Array.from(thumbGallery.children);
    const iframeItem = document.getElementById('mazing-iframe-item');
    const productMedia = document.querySelector('.product__top.product__primary .product__media');

    if (!productMedia) return;

    const getHeight = (el) => {
        if (!el) return 0;
        const style = window.getComputedStyle(el);
        return parseFloat(style.height) || el.offsetHeight || 0;
    };

    const updateProductMediaHeight = (slide) => {
        if (!slide) return;

        if (slide === iframeItem) {
            const height = getHeight(slide);
            if (height > 20) {
                productMedia.style.height = `${height}px`;
            }
            return;
        }

        const anchor = slide.querySelector('a');
        const img = anchor?.querySelector('img');

        const applyHeight = () => {
            const imgHeight = getHeight(img);
            const fallbackHeight = getHeight(anchor) || getHeight(slide);
            const finalHeight = imgHeight > 20 ? imgHeight : fallbackHeight;

            if (finalHeight > 20) {
                productMedia.style.height = `${finalHeight}px`;
            }
        };

        if (img && !img.complete) {
            img.onload = applyHeight;
        } else {
            applyHeight();
        }
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const currentSlide = entry.target;
                const index = slides.indexOf(currentSlide);

                updateProductMediaHeight(currentSlide);

                if (index !== -1 && index !== lockedActiveIndex) {
                    thumbs.forEach((thumb, i) => {
                        const btn = thumb.querySelector('button');
                        if (!btn) return;
                        btn.classList.toggle('active', i === index);
                    });
                    lockedActiveIndex = index;
                }
            }
        });
    }, {
        root: imgGallery,
        threshold: 0.6
    });

    slides.forEach(slide => observer.observe(slide));
};


const disableLazyLoading = (container) => {
    const images = container.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
        img.removeAttribute('loading');
    });
};


const initializeMazing = async () => {

    const desktopImgGallery = await waitForElement('.product__media-container.above-mobile.lightbox-media-container .product__media');
    const mobileImgGallery = await waitForElement('.product__media-container.below-mobile.lightbox-media-container .product__media .scroll-slider__slider');

    const desktopThumbGallery = await waitForElement('.product__media-container.above-mobile.lightbox-media-container .product-thumbnails__items');
    const mobileThumbGallery = await waitForElement('.product__media-container.below-mobile.lightbox-media-container .product-thumbnails__items');

    // const imgGallery = await waitForElement('.product__media-container.above-mobile.lightbox-media-container .product__media');
    // const thumbGallery = await waitForElement('.product__media-container.above-mobile.lightbox-media-container .product-thumbnails__items');

    const myImageSrc = 'https://cdn.mazing.link/assets/svg/3D.svg';

    iframeSrc = await mazingProjectAvailable({
        customerName: customer,
        getSKU: getCurrentSKU,
    });
    if (!iframeSrc) {
        console.log('iframeSrc not found, aborting script execution.');
        return;
    }


    if (window.innerWidth > 960) {
        insertIframe(desktopImgGallery, iframeSrc);
        syncIframeHeight(desktopImgGallery);
        assignSlideIndices(desktopImgGallery);

        cloneAndInsertThumb(desktopThumbGallery, myImageSrc);
        assignThumbnailIndices(desktopThumbGallery)
        setupThumbClickListeners(desktopThumbGallery, desktopImgGallery);

        window.addEventListener('resize', () => {
            // There is nothing to sync with if Mazing Solution is selected. So we only sync height if it's available
            if (!isMazingSelected) {
                syncIframeHeight(desktopImgGallery);
            }
        });
    } else {
        disableLazyLoading(mobileImgGallery);

        insertIframe(mobileImgGallery, iframeSrc);
        await waitForElement('#mazing-iframe-item');
        document.getElementById('mazing-iframe-item').style.height = '400px';
        assignSlideIndices(mobileImgGallery);

        cloneAndInsertThumb(mobileThumbGallery, myImageSrc);
        assignThumbnailIndices(mobileThumbGallery)
        setupThumbClickListenersMobile(mobileThumbGallery, mobileImgGallery);

        setTimeout(() => {
            preventExternalActiveManipulation(mobileThumbGallery)
            observeVisibleSlide(mobileImgGallery, mobileThumbGallery);
        }, 400);
    }

    console.log('Mazing initialized with clean DOM.');

    // Post Actions
    await initializeVariantListeners()
};

const initializeScript = async () => {
    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');
        await initializeMazing();
        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    }
};

initializeScript();
